import isbot from 'isbot'
import { Logger } from '~/plugins/log'

const logger = new Logger()
logger.setContext('Session')

const getSessionId = (commit, rootGetters) => {
  if (!rootGetters['store/sg18pid']) commit('store/CREATE_SG18PID', null, { root: true })
  return rootGetters['store/sg18pid']
}

const getDefaultState = () => ({
  userAgent: null,
  ignore: false,
  ignoreList: [
    'Pingdom.com',
    'Googlebot',
    'GoogleStackdriverMonitoring',
    'worldping-api'
  ]
})

export const state = getDefaultState

export const mutations = {
  SET_USER_AGENT (state, userAgent) {
    state.userAgent = userAgent
    state.ignoreList.forEach((ignoreUA) => {
      if ((state.userAgent || '').toLowerCase().includes(ignoreUA.toLowerCase())) state.ignore = true
    })
    if (isbot(state.userAgent)) state.ignore = true
  }
}

export const getters = {
  ignore: state => state.ignore
}

export const actions = {
  async UPDATE ({ commit, getters, rootGetters, rootState }, body) {
    if (getters.ignore) return

    try {
      body.language = body.language || this.$i18n.locale.split('-')[0]
      body.country = body.country || rootGetters['store/subdomain']
      body.latest_page = body.latest_page || rootState.route.path

      const sessionId = getSessionId(commit, rootGetters)

      await this.$publicAPI.quietPost(`session/${sessionId}/store/`, body, { log: false })
    } catch (error) {
      this.app.$sentry.captureException(error)
    }
  },
  async SUBSCRIBE ({ commit, rootGetters }, email) {
    try {
      const sessionId = getSessionId(commit, rootGetters)

      const { data } = await this.$publicAPI.quietPost(`session/${sessionId}/subscribe/`, { email })
      return data
    } catch (error) {
      this.app.$sentry.captureException(error)
      logger.error(error)
      return { error: true }
    }
  },
  async SUBSCRIBE_COMPETITION ({ commit, rootGetters }, { email, comp }) {
    try {
      const sessionId = getSessionId(commit, rootGetters)

      const { data } = await this.$publicAPI.post(`session/${sessionId}/subscribe/`, { email, comp })
      return data
    } catch (error) {
      this.app.$sentry.captureException(error)
      logger.error(error)
      return { error: true }
    }
  },
  async GET ({ commit, getters, rootGetters }) {
    if (getters.ignore) return

    try {
      const sessionId = getSessionId(commit, rootGetters)

      const { data } = await this.$publicAPI.quietGet(`session/${sessionId}/`, { log: false })
      return data
    } catch (error) {
      this.app.$sentry.captureException(error)
      logger.error(error)
      return {}
    }
  },
  async TRACK ({ commit, getters, rootGetters }, { sku = null, event, body = null }) {
    if (getters.ignore) return

    const requestBody = {
      event,
      sku,
      event_body: body,
      store: rootGetters['store/websiteId']
    }

    try {
      const sessionId = getSessionId(commit, rootGetters)

      await this.$publicAPI.quietPost(`session/${sessionId}/track/`, requestBody, { log: false })
    } catch (error) {
      this.app.$sentry.captureException(error)
      logger.error(error)
    }
  },
  async TRACK_LANDING ({ commit, getters, rootGetters }, { rl, landingPage }) {
    if (getters.ignore) return

    try {
      const sessionId = getSessionId(commit, rootGetters)

      await this.$publicAPI.quietPost(`session/${sessionId}/landing/`, { rl, landingPage })
    } catch (error) {
      this.app.$sentry.captureException(error)
      logger.error(error)
    }
  },
  async TRACK_POST_CHECKOUT_RATING (_, { orderId, stars }) {
    if (!orderId || !stars) return

    try {
      await this.$publicAPI.post('reviews/post_checkout_stars_rating/', { order_id: orderId, stars })
    } catch (error) {
      this.app.$sentry.captureException(error)
      logger.error(error)
    }
  }
}